import { Box } from "@mui/material";
import { DotLegalButton } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { excelIcon } from "@common/icons";
import PlanDialogWrapper from "../../../plan/planDialogWrapper/planDialogWrapper";
import { listPageToolbarIconButton, listPageToolbarIconButtonSize } from "@common/components/listPageToolbar/ListPageToolbar.styles";

interface ExcelExportButtonProps {
    onClick: () => void;
    isLoading?: boolean;
    isDisabled?: boolean;
    isPlanLocked?: boolean;
    planLockedText?: string;
}

function ExcelExportButton(props: ExcelExportButtonProps) {
    const { translateString } = useTranslation();

    return (
        <PlanDialogWrapper enabled={!!props.isPlanLocked} text={props.planLockedText ?? ""}>
            <Box sx={listPageToolbarIconButton}>
                <DotLegalButton
                    btnLength={listPageToolbarIconButtonSize}
                    disabled={props.isLoading || props.isDisabled || props.isPlanLocked}
                    isLoading={props.isLoading}
                    onClick={props.onClick}
                    buttonType={"secondary"}
                    toolTip={props.isPlanLocked ? props.planLockedText : translateString("exportToExcel")}
                >
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", "& svg": { width: 20, height: 20 } }}>{excelIcon}</Box>
                </DotLegalButton>
            </Box>
        </PlanDialogWrapper>
    );
}

export default ExcelExportButton;
